export const EXPORT_CHECK_LIST_XLSX_FILE_NAME = 'martInspections.xlsx';
export const EXPORT_CHECK_LIST_ODS_FILE_NAME = 'martInspections.ods';
